import { unfavoritePremiumItem } from './premiumContent.api';
import type {
  MarketplaceRemoveFromSavedArgs,
  MarketplaceAddToSavedArgs,
  FetchMarketplaceArgs,
  FetchLibraryArgs,
} from './types/marketplace.types';
import type {
  ApiMarketplace,
  UiMarketplace,
} from '../schemas/marketplace.schema';

import { mapMarketplaceFromApi } from './mappers/marketplace.mappers';
import { postWithPagination, destroy, get } from './axios';

export const fetchMarketplace = async ({
  contentFilters,
  locale,
  tableFilters,
  // userUnitSettings,
}: FetchMarketplaceArgs) => {
  const { search, ...restTableFilters } = tableFilters;
  const { authorIds, contentType, equipmentTags, organizationIds, tags } =
    contentFilters || {};
  const params = {
    ...restTableFilters,
    status: 'active',
    ...(search ? { search } : {}),
    authorIds,
    contentType,
    equipmentTagIds: equipmentTags || undefined,
    organizationIds,
    tagIds: tags || undefined,
  };
  const response = await postWithPagination<ApiMarketplace[]>(
    `/v2/marketplace`,
    params,
  );
  if (!response?.data) return null;
  return {
    ...response,
    data: response?.data
      .map((exercise) => mapMarketplaceFromApi(locale, exercise))
      .filter(Boolean) as UiMarketplace[],
  };
};

export const fetchLibrary = async ({
  contentFilters,
  locale,
  tableFilters,
}: FetchLibraryArgs) => {
  const { search, ...restTableFilters } = tableFilters;
  const { authorIds, contentType, equipmentTags, organizationIds, tags } =
    contentFilters || {};
  const params = {
    ...restTableFilters,
    status: 'active',
    ...(search ? { search } : {}),
    authorIds,
    contentType,
    equipmentTagIds: equipmentTags || undefined,
    organizationIds,
    tagIds: tags || undefined,
  };

  const response = await postWithPagination<ApiMarketplace[]>(
    `/v2/my-library`,
    params,
  );
  if (!response?.data) return null;
  return {
    ...response,
    data: response?.data
      .map((exercise) => mapMarketplaceFromApi(locale, exercise))
      .filter(Boolean) as UiMarketplace[],
  };
};

export const addToSaved = async ({ id }: MarketplaceAddToSavedArgs) => {
  await get<void>(`/v2/marketplace/${id}/add-to-lib`);
};

export const removeFromSaved = async ({
  id,
  isPremiumFavorite,
}: MarketplaceRemoveFromSavedArgs) => {
  if (isPremiumFavorite) {
    await unfavoritePremiumItem(id);
    return;
  }
  await destroy(`/v2/my-library/${id}`);
};
